import { useLocation } from 'react-router-dom';

export const useBaseUrl = () => {
    return new URLSearchParams(useLocation().search);
};

export const baseUrl = () => process.env.REACT_APP_API_ROOT;

/**
 * Access URL Query parameters.
 *  @example
 *  //Current URL = http://foo/bar?filter=baz. 
 *  const query = useUrlQuery();
 *  query.get('filter'); //will return 'baz'
 * 
 */
export const useUrlQuery = () => {
    return new URLSearchParams(useLocation().search);
}

